@if(form) {
  <mat-form-field [appearance]="this.appearance" [formGroup]="form" color="primary" [class]="`lookup-field ${this.className}` " >
    @if (this.label) {
      <mat-label>{{this.label}}</mat-label>
    }
    @if(this.icon) {
      <lib-app-icon [icon]="this.icon" matSuffix [size]="'48x48'" className="p-[12px]" />
    }
    <mat-select [id]="this.key" [formControlName]="this.key" [(value)]="this.value" 
      (selectionChange)="this.onSelectChange($event)" [errorStateMatcher]="errorStateMatcher"> 
      @for (option of this.internalOptions; track option.value) {
        <mat-option [value]="option.value">{{option.viewValue}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
} @else {
  <mat-form-field [appearance]="this.appearance" color="primary" [class]="this.className" >
    @if (this.label) {
      <mat-label>{{this.label}}</mat-label>
    }
  
    @if(this.icon) {
      <lib-app-icon [icon]="this.icon" matSuffix [size]="'48x48'" className="p-[12px]" />
    }
    
    <mat-select [id]="this.key" [(value)]="this.value" (selectionChange)="this.onSelectChange($event)" [errorStateMatcher]="errorStateMatcher">
      @for (option of this.internalOptions; track option.value) {
        <mat-option [value]="option.value">{{option.viewValue}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
}